import React, { createContext, useContext, useEffect, useState } from 'react';

const ClockTickContext = createContext(0);

export function ClockTickProvider({ children }) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <ClockTickContext.Provider value={tick}>
      {children}
    </ClockTickContext.Provider>
  );
}

export const useClockTick = () => useContext(ClockTickContext);
